<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--team">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <!-- メインコンテンツ: 上段共通エリア -->
      <content-header title="ユーザー管理" :link-url="linkUrl" :link-text="linkText" />
      <!-- /メインコンテンツ: 上段共通エリア -->

      <!-- チームユーザーの一覧 -->
      <team-users :team-data="teamData" />
      <!-- /チームユーザーの一覧 -->
    </main>
    <!-- /メインコンテンツエリア -->
  </div>
  <!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    contractData: Object,
    teamData: Object,
    linkUrl: String,
    linkText: String,
  },
}
</script>
